export const environment = {
  production: false,
  idleTimeOutDuration: 1800,
  idleTimeOutCountDown: 30,
  authServiceUrl: 'https://hub-keycloak.demo.irembolabs.com',
  authRealm: 'irembo',
  authClientId: 'organization-management-portal',
  authSuccessRedirectUrl: 'https://organization-portal.demo.irembolabs.com',
  authorizationServiceBaseUrl: 'https://auth-engine.demo.irembolabs.com/auth',
  apiGatewayBaseUrl: 'https://organization-gateway.demo.irembolabs.com',
  citizenPortalUrl: 'https://citizen-portal.demo.irembolabs.com',
  translationSourceUrl: 'https://citizen-gateway.sandbox.iremboinc.com',
  translationApiGatewayBaseUrl:
    'https://organization-gateway.sandbox.iremboinc.com',
  AESEncryptionKey: 'encryptionKey',
  isDocumentScanningEnabled: true,
  IS_SENDING_ANALYTICS_EVENTS_ACTIVE: false,
  MIXPANEL_TOKEN: 'fb2a9200be250ed27bfaca86b6a0d989',
};
